import { AxiosResponse } from 'axios';
import { useFormik } from 'formik';
import { useEffect, useRef, useState } from 'react';
import { useAuth } from 'src/contexts/auth';
import { ModelOfProductGroup } from '../../database';
import api from '../../services/api';
import * as Yup from 'yup';

export const useListProductGroupController = () => {
	const [ProductGroupData, setProductGroupsData] = useState<ModelOfProductGroup[]>([]);
	const [selectedProductGroup, setSelectedProductGroup] = useState<ModelOfProductGroup>();
	const [loading, setLoading] = useState(true);
	const [editDialog, setEditDialog] = useState(false);
	const [deleteDialog, setDeleteDialog] = useState(false);

	const { userAgencyId } = useAuth();
	const toast: any = useRef();

	const validationSchema = Yup.object().shape({
		DESCRICAO: Yup.string().required('* Campo obrigatório'),
	});

	const getProductGroups = () => {
		api.get(`groups/${userAgencyId}`)
			.then(response => {
				const data = response.data;
				setProductGroupsData(data);
				setLoading(false);
			})
			.catch((response: AxiosResponse) => {
				console.log('erro: ', response.status);
				setLoading(false);
			});
	};

	const removeProductGroup = (ProductGroup: ModelOfProductGroup) => {
		setLoading(true);
		api.delete(`groups/${ProductGroup.ID}`)
			.then(() => {
				getProductGroups();
				setDeleteDialog(false);
				setLoading(false);
				toast.current.show({
					severity: 'success',
					summary: 'Remoção realizada',
					detail: 'A marca foi removida com sucesso!',
					life: 5000,
				});
			})
			.catch(err => {
				getProductGroups();
				setDeleteDialog(false);
				setLoading(false);
				toast.current.show({
					severity: 'error',
					summary: 'Remoção não realizado',
					detail: 'Falha ao realizar operação!',
					life: 5000,
				});
			});
	};

	const editProductGroup = (ProductGroup: ModelOfProductGroup) => {
		setLoading(true);

		const editedProductGroup: ModelOfProductGroup = {
			...ProductGroup,
			ORGAO: userAgencyId,
		};

		api.put(`groups/${selectedProductGroup?.ID}`, editedProductGroup)
			.then(() => {
				getProductGroups();
				setEditDialog(false);
				setLoading(false);
				toast.current.show({
					severity: 'success',
					summary: 'Edição realizada',
					detail: 'O grupo foi editada com sucesso!',
					life: 5000,
				});
			})
			.catch(err => {
				getProductGroups();
				setEditDialog(false);
				setLoading(false);
				toast.current.show({
					severity: 'error',
					summary: 'Edição não realizado',
					detail: 'Falha ao realizar operação!',
					life: 5000,
				});
			});
	};

	useEffect(() => {
		getProductGroups();
	}, []);

	const openDeleteDialog = (ProductGroup: ModelOfProductGroup) => {
		setDeleteDialog(true);
		setSelectedProductGroup(ProductGroup);
	};

	const closeDeleteDialog = () => {
		setDeleteDialog(false);
	};

	const openEditDialog = (ProductGroup: ModelOfProductGroup) => {
		setEditDialog(true);
		setSelectedProductGroup(ProductGroup);
	};

	const closeEditDialog = () => {
		setEditDialog(false);
	};

	const formik = useFormik<ModelOfProductGroup>({
		initialValues: {
			ORGAO: '',
			DESCRICAO: '',
		},
		onSubmit: values => editProductGroup(values),
		validationSchema,
	});

	return {
		getProductGroupListController: {
			formik,
			ProductGroupData,
			selectedProductGroup,
			loading,
			deleteDialog,
			editDialog,
			toast,
		},
		handleProductGroupListController: {
			removeProductGroup,
			editProductGroup,
			openDeleteDialog,
			closeDeleteDialog,
			openEditDialog,
			closeEditDialog,
			getProductGroups,
		},
	};
};
